import {Route} from '@angular/router';
import {PrivacyPolicyComponent} from './privacy-policy/PrivacyPolicyComponent';
import {NotFoundComponent} from './not-found/NotFoundComponent';

export const AppRouting: Route[] = [
    {path: 'privacy', component: PrivacyPolicyComponent},
    {path: '**', component: NotFoundComponent}
];
